export default __webpack_public_path__ + "static/media/bannerIcon.56b20332.svg";